import {
  Box,
  Container,
  Typography,
  Card,
  CardContent,
  Stack,
  Button,
} from "@mui/material";
import React from "react";
import EmailIcon from "@mui/icons-material/Email";
import PhoneIphoneIcon from "@mui/icons-material/PhoneIphone";
import InstagramIcon from "@mui/icons-material/Instagram";
import { Helmet } from "react-helmet-async";

const Rentals = () => {
  return (
    <>
    <Helmet>
      <title>Rent a Claw Machine in Ottawa | Den Den Claw</title>
      <meta
        name="description"
        content="Rent a claw machine from Den Den Claw for your event, birthday party, or pop-up in Ottawa. Contact us for pricing and availability."
      />
      <link rel="canonical" href="https://www.dendenclaw.com/explore/rentals" />
    </Helmet>
    <Box sx={{ py: 6 }}>
      <Container maxWidth="md">
        {/* ---------- HEADER ---------- */}
        <Typography
          variant="h4"
          sx={{ fontWeight: 700, textAlign: "center", mb: 2 }}
        >
          Rentals 🎯
        </Typography>

        <Typography
          variant="subtitle1"
          sx={{
            textAlign: "center",
            maxWidth: 700,
            mx: "auto",
            mb: 6,
            color: "text.secondary",
          }}
        >
          Bring the Den Den Claw experience to your event!
          Our claw machine rentals are great for tradeshows,
          pop-ups, corporate events, and special occasions.
        </Typography>

        {/* ---------- OPTIONAL IMAGE PLACEHOLDER ---------- */}
        <Box
          component="img"
          src="/rentals/placeholder.jpg" // TODO: add rental photo if desired
          alt="Claw machine rental setup"
          sx={{
            width: "100%",
            maxHeight: 360,
            objectFit: "cover",
            borderRadius: 3,
            mb: 6,
          }}
        />

        {/* ---------- INFO CARD ---------- */}
        <Card
          sx={{
            borderRadius: 3,
            boxShadow: 6,
            p: 4,
            mb: 6,
          }}
        >
          <CardContent>
            <Typography variant="h6" sx={{ fontWeight: 600, mb: 2 }}>
              What We Need for a Quote 📋
            </Typography>

            <Typography sx={{ mb: 2 }}>
              Every rental is different, so we’ll ask for a bit of information
              to build the right setup for your event:
            </Typography>

            <Stack spacing={1.2} sx={{ mb: 3 }}>
              <Typography>• Event date</Typography>
              <Typography>• Setup hours</Typography>
              <Typography>• Takedown hours</Typography>
              <Typography>• Delivery required?</Typography>
              <Typography>• On-site attendant and support needed?</Typography>
              <Typography>• Toys provided or custom items required?</Typography>
            </Stack>

            <Typography>
              Once we have these details, we can craft a custom package that
              fits your needs and budget.
            </Typography>
          </CardContent>
        </Card>

        {/* ---------- SPECIAL PRICING ---------- */}
        <Card
          sx={{
            borderRadius: 3,
            boxShadow: 6,
            p: 4,
            mb: 6,
            background: "linear-gradient(180deg, #e8f2ff 0%, #f5faff 100%)",
          }}
        >
          <CardContent>
            <Typography variant="h6" sx={{ fontWeight: 600, mb: 2 }}>
              Fundraisers & Charity Events 💙
            </Typography>

            <Typography>
              We offer special pricing for fundraisers and charity events.
              If you’re raising money for a cause or hosting a community-driven
              event, let us know — we’d love to help support it.
            </Typography>
          </CardContent>
        </Card>

        {/* ---------- CONTACT CTA ---------- */}
        {/* ---------- CONTACT CTA ---------- */}
<Card
  sx={{
    borderRadius: 3,
    boxShadow: 6,
    p: 4,
    textAlign: "center",
  }}
>
  <CardContent>
    <Typography variant="h6" sx={{ fontWeight: 600, mb: 2 }}>
      Contact Us For A Quote
    </Typography>

    <Typography sx={{ mb: 3, color: "text.secondary" }}>
      Tell us about your event and we’ll help build the right setup for you.
    </Typography>

    <Stack
      direction={{ xs: "column", sm: "row" }}
      spacing={2}
      justifyContent="center"
    >
      {/* EMAIL */}
      <Button
        variant="contained"
        startIcon={<EmailIcon />}
        href={
          "mailto:dendendori@gmail.com" +
          "?subject=Claw%20Machine%20Rental%20Inquiry" +
          "&body=Hi%20Den%20Den%20Claw!%0A%0AI’m%20interested%20in%20renting%20claw%20machines%20for%20an%20event.%0A%0AEvent%20date:%0ASetup%20hours:%0ATakedown%20hours:%0ADelivery%20needed:%0AOn-site%20attendant%20needed:%0AToys%20or%20custom%20items:%0A%0AThanks!"
        }
        sx={{
          borderRadius: 999,
          px: 3,
          textTransform: "none",
          fontWeight: 600,
        }}
      >
        dendendori@gmail.com
      </Button>

      {/* TEXT */}
      <Button
        variant="outlined"
        startIcon={<PhoneIphoneIcon />}
        href="tel:16134002909"
        sx={{
          borderRadius: 999,
          px: 3,
          textTransform: "none",
          fontWeight: 600,
        }}
      >
        (613) 400-2909
      </Button>

      {/* INSTAGRAM */}
      <Button
        variant="outlined"
        startIcon={<InstagramIcon />}
        href="https://instagram.com/dendenclaw"
        target="_blank"
        sx={{
          borderRadius: 999,
          px: 3,
          textTransform: "none",
          fontWeight: 600,
        }}
      >
        @dendenclaw
      </Button>
    </Stack>
  </CardContent>
</Card>

      </Container>
    </Box>
    </>
  );
};

export default Rentals;
